import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { flyoutListSx } from "./styles";
import { pathMatches, type NavSection } from "./navItems";

interface FlyoutLinkListProps {
  /** Items carry their final link target in `path`. Empty sections are skipped. */
  sections: NavSection[];
  /** Called after a link is chosen, to close the flyout. */
  onNavigate: () => void;
}

/** The sections of links in a sidebar flyout (Explore, Platform). */
export default function FlyoutLinkList({ sections, onNavigate }: FlyoutLinkListProps) {
  const { pathname } = useLocation();
  return (
    <List disablePadding sx={flyoutListSx}>
      {sections
        .filter((section) => section.items.length > 0)
        .map((section, i) => (
          <Fragment key={section.heading ?? i}>
            {section.heading && <ListSubheader disableSticky>{section.heading}</ListSubheader>}
            {section.items.map((item) => (
              <ListItemButton
                key={item.path}
                component={Link}
                to={item.path}
                selected={pathMatches(pathname, item.path)}
                onClick={onNavigate}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))}
          </Fragment>
        ))}
    </List>
  );
}
